/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitAcquisitionState } from '../../models/unit-acquisition-state';

export interface GetUnitsAcquisitionParameters$Params {
}

export function getUnitsAcquisitionParameters(http: HttpClient, rootUrl: string, params?: GetUnitsAcquisitionParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UnitAcquisitionState>>> {
  const rb = new RequestBuilder(rootUrl, getUnitsAcquisitionParameters.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UnitAcquisitionState>>;
    })
  );
}

getUnitsAcquisitionParameters.PATH = '/units/acquisition-parameters';
